import { render, staticRenderFns } from "./FiltroPedidos.vue?vue&type=template&id=203c1d6e&"
import script from "./FiltroPedidos.vue?vue&type=script&lang=js&"
export * from "./FiltroPedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports